import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Stack } from '@tymate/margaret';
import { fontStyles } from 'ui';
import { formatDate } from 'utils';
import { isPast } from 'date-fns';
import { Calendar2Event } from 'react-bootstrap-icons';

const Wrapper = styled(Stack)`
  ${fontStyles.bodySmall}

  color: ${({ theme }) => theme.textLight};
  height: 22px;

  ${({ isOverdue }) =>
    isOverdue &&
    css`
      color: ${({ theme }) => theme.warning};
    `}

  ${({ variant }) =>
    variant === 'requestDetail' &&
    css`
      ${fontStyles.body};
      color: ${({ theme }) => theme.textLighter};
    `}
`;

const Deadline = ({ deadline, variant }) => {
  const { t } = useTranslation('misc');

  if (!deadline) {
    return null;
  }

  const isOverdue = isPast(new Date(deadline));

  return (
    <Wrapper
      marginVertical={0}
      alignY="center"
      gutterSize={0.25}
      isOverdue={isOverdue}
      variant={variant}
    >
      <Calendar2Event />

      <span>
        {t(isOverdue ? 'overdue' : 'due', {
          deadline: formatDate(deadline, 'dd MMM yyyy'),
        })}
      </span>
    </Wrapper>
  );
};

export default Deadline;
